import { render, staticRenderFns } from "./Dash-audience-many.vue?vue&type=template&id=0dda14d8"
import script from "./Dash-audience-many.vue?vue&type=script&lang=js"
export * from "./Dash-audience-many.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports